import { iconMap } from '@/pages/Products/VpsOciDetailPage/icons/iconMap';
import { productsActions } from '@/redux/modules';
import {
  openUrl,
  Management as ManagementRedirects,
  snapshotRedirect,
  openDomainUrl,
} from '@/utils/navigation/redirects';
import { locale } from '@/utils/locale';
import { backupAnalytics } from '@/analytics';

export const checkExistSlug = (slug, managementLocale) => {
  if (!managementLocale?.management?.items) return true;
  return !slug || slug === '' || managementLocale.management.items.findIndex(itemLocale => itemLocale.slug === slug) === -1;
};

export const getIconBySlug = (slug) => {
  const lowerSlug = slug.toLowerCase();

  if (iconMap[lowerSlug]) {
    return iconMap[lowerSlug];
  }

  const matchingKey = Object.keys(iconMap).find(key => lowerSlug.includes(key.toLowerCase()));
  return matchingKey ? iconMap[matchingKey] : null;
};

// Cria o mapa de ações disponíveis
const getActionsMap = ({
  productId,
  serverIp,
  domain,
  onGoToTemplatesPage,
  onGoToSshKeysPage,
  n8nState,
  dispatch,
}) => ({
  cpanel: () => ManagementRedirects.cpanelRedirect(productId, locale),
  n8n: () => {
    if (!n8nState || !productsActions || !productsActions.n8n) return;

    const openN8N = (ip) => {
      const url = `http://${ip}`;
      openUrl(url);
    };

    if (n8nState.data && n8nState.hostingId === productId) {
      openN8N(n8nState.data.ip);
    } else {
      dispatch(productsActions.n8n.request({ hostingId: productId, actionType: 'open_n8n', callback: openN8N }));
    }
  },
  plesk: () => ManagementRedirects.pleskRedirect(serverIp),
  'wordpress-1-clique': () => openDomainUrl(domain),
  'wordpress-openlitespeed': () => openDomainUrl(domain),
  wordpress: () => openDomainUrl(domain),
  docker: () => ManagementRedirects.dockerRedirect(serverIp),
  moodle: () => ManagementRedirects.moodleRedirect(serverIp),
  'node-js': () => ManagementRedirects.nodejsRedirect(serverIp),
  woocommerce: () => ManagementRedirects.woocommerceRedirect(domain),
  pterodactyl: () => ManagementRedirects.pterodactylRedirect(serverIp),
  laravel: () => ManagementRedirects.laravelRedirect(serverIp),
  cyberpanel: () => ManagementRedirects.cyberPanelRedirect(serverIp),
  magento: () => ManagementRedirects.magentoRedirect(domain),
  supabase: () => ManagementRedirects.supabaseRedirect(serverIp),
  'kubernetes-k3s': () => ManagementRedirects.kubernetesRedirect(serverIp),
  easypanel: () => ManagementRedirects.easyPanelRedirect(serverIp),
  webmin: () => ManagementRedirects.webminRedirect(serverIp),
  virtualmin: () => ManagementRedirects.virtualminRedirect(serverIp),
  'so-apps': () => onGoToTemplatesPage && onGoToTemplatesPage(),
  backup: () => {
    backupAnalytics.backupButtonClick();
    ManagementRedirects.backupRedirect(productId, locale);
  },
  snapshot: () => snapshotRedirect(productId, locale),
  'ssh-keys': () => onGoToSshKeysPage && onGoToSshKeysPage(),
  openclaw: () => ManagementRedirects.openClawRedirect(serverIp),
  gatorclaw: () => ManagementRedirects.gatorClawRedirect(serverIp),
  'evolution-go': () => ManagementRedirects.evolutionGoRedirect(serverIp),
  'evolution-api': () => ManagementRedirects.evolutionApiRedirect(serverIp),
  'evolution-crm': () => ManagementRedirects.evolutionCrmRedirect(serverIp),
});

/**
 * Verifica se existe uma ação para o slug
 */
export const hasSlugAction = (slug) => {
  // Cria um mapa dummy só para verificar se a key existe
  const actionsMap = getActionsMap({});
  return slug in actionsMap;
};

/**
 * Executa a ação correspondente ao slug
 * @param {string} slug - O slug da aplicação/serviço
 * @param {Object} params - Parâmetros necessários para execução
 * @param {string} params.productId - ID do produto
 * @param {string} params.serverIp - IP do servidor
 * @param {string} params.domain - Domínio do servidor
 * @param {Function} params.onGoToTemplatesPage - Callback para ir à página de templates
 * @param {Function} params.onGoToSshKeysPage - Callback para ir à página de SSH Keys
 * @param {Object} params.n8nState - Estado do n8n
 * @param {Function} params.dispatch - Dispatch do Redux
 */
export const executeSlugAction = (slug, params) => {
  if (!slug) return;

  const actions = getActionsMap(params);
  const action = actions[slug];

  if (action) {
    try {
      action();
    } catch (error) {
      // Silently fail to prevent application crash
    }
  }
};
